import { useEffect, useState } from "react";
import { MessageInputProps } from "./MessageInput";

type UseWithMessageInputProps = Pick<
  MessageInputProps,
  | "id"
  | "name"
  | "placeHolder"
  | "initialInputValue"
  | "disabled"
  | "isIconVisible"
  | "handleCancelNote"
>;

const useWithMessageInput = ({
  disabled,
  id,
  isIconVisible,
  name,
  placeHolder,
  handleCancelNote,
  initialInputValue,
}: UseWithMessageInputProps) => {
  const [inputValue, setInputValue] = useState<string>(initialInputValue || "");

  const handleInputChange = (input: string) => {
    setInputValue(input);
  };

  useEffect(() => {
    setInputValue(initialInputValue || "");
  }, [initialInputValue]);

  return {
    disabled,
    id,
    isIconVisible,
    name,
    placeHolder,
    value: inputValue,
    handleCancelNote,
    handleInputChange,
  };
};

export default useWithMessageInput;
